import Select, { components } from 'react-select'
import { ReactComponent as CloseIcon } from 'assets/icons/close12.svg'

import './react-select-overwrites.scss'

interface Props {
  options: ({ value: string | undefined; label: string | undefined } | undefined)[]
  selected: ({ value: string | undefined; label: string | undefined } | undefined)[]
  setSelected: (domains: any) => void
  placeholder?: string
  noOptionsMessage?: string
  overrideSelectComponents?: any
  selectProps?: any
}

const MultiSelector = ({
  options,
  selected,
  setSelected,
  placeholder,
  noOptionsMessage,
  overrideSelectComponents,
  selectProps,
}: Props) => {
  // Adds a custom no options message
  const NoOptionsMessage = (props: any) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>{noOptionsMessage}</span>
      </components.NoOptionsMessage>
    )
  }

  const overrideComponents = {
    NoOptionsMessage,
    DropdownIndicator,
    ClearIndicator,
    MultiValueRemove,
    ...overrideSelectComponents,
  }

  return (
    <div id="multiSelect">
      <Select
        {...selectProps}
        isMulti
        name="allowed-domains"
        className="react-select"
        classNamePrefix="react-select"
        inputId={'allowed-domains-select'}
        components={overrideComponents}
        menuPlacement="auto"
        onChange={setSelected}
        options={options}
        placeholder={placeholder}
        tabSelectsValue={false}
        value={selected}
      />
    </div>
  )
}

// This removes the default dropdown arrow
const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <></>
    </components.DropdownIndicator>
  )
}

// This replaces the default with text and icon.
const ClearIndicator = (props: any) => {
  return (
    <components.ClearIndicator {...props}>
      <span>Clear All</span>
      <CloseIcon />
    </components.ClearIndicator>
  )
}

// This replaces the default icon.
const MultiValueRemove = (props: any) => {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon />
    </components.MultiValueRemove>
  )
}

export default MultiSelector
